"use client";

import { useSyncExternalStore } from "react";
import { mercuryLogoAssets, mercuryLogoSidebarSrc, type AppearanceMode } from "@/lib/brand-assets";

export function readAppearanceMode(): AppearanceMode {
  if (typeof document === "undefined") return "light";
  return document.documentElement.dataset.appearance === "dark" ? "dark" : "light";
}

function subscribeAppearance(onStoreChange: () => void) {
  window.addEventListener("mercuryos-theme-change", onStoreChange);
  return () => window.removeEventListener("mercuryos-theme-change", onStoreChange);
}

function getAppearanceServerSnapshot(): AppearanceMode {
  return "light";
}

export function useAppearanceMode(): AppearanceMode {
  return useSyncExternalStore(
    subscribeAppearance,
    readAppearanceMode,
    getAppearanceServerSnapshot,
  );
}

export function useMercurySidebarLogo() {
  const appearance = useAppearanceMode();
  return mercuryLogoSidebarSrc(appearance);
}

export function useMercuryLogoAssets(cssPx: number) {
  const appearance = useAppearanceMode();
  return mercuryLogoAssets(cssPx, appearance);
}
